module.exports = __webpack_public_path__ + "img/RGB_AI_60.jpg";